import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { CancelsensorComponent } from '../cancelsensor/cancelsensor.component';
import { AuthService } from 'src/app/services/auth.service';
import { TaskService } from 'src/app/services/task.service';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { ToasterService } from 'src/app/services/snackbar.service';
import { UserService } from 'src/app/services/user.service';
import { CancelpaylaterComponent } from '../payment/cancelpaylater/cancelpaylater.component';
import { DesktopVersionComponent } from './desktop-version/desktop-version.component';
import { environment } from 'src/environments/environment';
import { ANSWER_FIRST, FEEDS, OPERATORS, QUESTION_BASED_WORKFLOW, STATUS_MAP } from 'src/app/services/constants';
import { ToiWarningPopupComponent } from './toi-warning-popup/toi-warning-popup.component';
import { FeasibilityComponent } from './feasibility/feasibility.component';
import { PopupService } from 'src/app/services/popup.service';
import { DataService } from 'src/app/services/data.service';
import { CancelinvoiceComponent } from '../orders/cancelinvoice/cancelinvoice.component';
import { CatalogsPopupComponent } from './catalogs-popup/catalogs-popup.component';
import { StarRatingComponent } from './star-rating/star-rating.component';
import { lastValueFrom, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OpportunityComponent } from './opportunity/opportunity.component';
import { LeafletNewpreviewComponent } from '../leaflet-newpreview/leaflet-newpreview.component';
import { UtilsService } from 'src/app/services/utils.service';
import { SessionTrackerService } from 'src/app/services/session-tracker.service';
import { PosthogService } from 'src/app/services/posthog.service';
import { INDICES_DELIVERY_TIME } from './../../services/constants';
import { CollectionPopupComponent, PreviescreenComponent, ConfirmPopupComponent } from '../shared';
import { TaskTypeModalComponent } from './task-type/task-type.component';
import { RetaskOptionsDialogComponent } from './retask-options-dialog/retask-options-dialog.component';

const TASKTABS = [
  { name: 'Recent', value: 'recent', heading: 'Recent Tasks' },
  { name: 'Received', value: 'received', heading: 'Received Tasks' },
  { name: 'Canceled', value: 'canceled', heading: 'Canceled Tasks' },
  { name: 'All', value: 'tasklist', heading: 'All Tasks' },
];

@Component({
  selector: 'app-my-task',
  templateUrl: './my-task.component.html',
  styleUrls: ['./my-task.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class MyTaskComponent implements OnInit, AfterViewInit {
  private cancelPendingRequests = new Subject<void>();
  private latestRequestId = 0;
  panelOpenState: boolean = false;
  icon: boolean = false;
  displayedColumns: string[] = [
    'position',
    'taskname',
    'createddate',
    'startdue',
    'enddue',
    'taskcost',
    'frequency',
    'repeatfrequency',
    'ISTask',
    'button',
    'preview',
    'action',
    'rating'
  ];
  dataSource = new MatTableDataSource<any>();
  tableDataLength: any;
  color = '#1059a9';
  fontweight = '700';
  CARTDATA: any[] = [];
  todayDate: Date = new Date();

  expandedElement: any;
  currentUser: any;
  curOption: any;
  NAVLISTRT: any;
  tasktabs: any;
  tasksCount: any;
  userid: any;
  resolutionColumn:string = "Resolution";
  selectedSensors: any = [];
  selectedCost = 0;

  length = 0;
  pageSize = 10;
  pageIndex = 0;
  pageSizeOptions = [10, 20, 50];
  showFirstLastButtons = true;
  interval: any;
  refreshCount = 0;
  taskData: any = [];
  innerDisplayedColumns: string[] = [
    'name',
    'resolution',
    'unit',
    'latency',
    'cloudcover',
    'cost',
    'status',
    'action',
  ];
  innerNameDisplay: string[] = [
    'check',
    'sensorname',
    'taskid',
    'resolution',
    'unit',
    'tasking',
    'cloudcover',
    'firstcapture',
    'lastcapture',
    'sensorcost',
    'oprtyTask',
    'feeds',
    'status',
    'action',
  ];
  columnsToDisplay: string[] = [
    'project',
    'taskname',
    'id',
    'openWindow',
    'closeWindow',
    'taskcost',
    'frequency',
    'repeatFrequency',
    'ISTask',
    'status',
    'preview',
    'action',
  ];
  innerNameDisplayFeedBased = [
  'check',
  'questionName',
  'questionId',
  'cost',
  'status',
  'tasking'
];
  feed = {
  questionName: 'What is the oil spill area?',
  questionId: 'QUESTION66766225626633',
  cost: 4000
};

  sortedData: any;
  check = false;
  load: boolean;
  cancelEnabled: boolean = false;
  rejectedEnabled: boolean = false;
  cancelPolicy: any = [];
  detailsText: any = '';
  policy: any;
  tooltipDisabled = true;
  satellogic: boolean = false;
  filterName: string;
  operators: any;
  allTask: boolean = false;
  taskLength: any;
  selectedTasks: any = [];
  order: boolean = false;
  orderPending: boolean = false;
  demoView: boolean = false;
  OPERATORS: any;
  tabSelected: any = 'recent';
  umbra: boolean;
  noFeasibilty: boolean;
  cancelFeasibility: boolean = true;
  head: boolean = false;
  retaskDisable: boolean = true;
  darkTheme: boolean;
  tooltipImagePath: string;
  orbitImage: string;
  allocated: boolean = false;
  isServices: any = '';
  projectData: any = [];
  projectName: any;
  isFilterPanelExpanded: boolean = false;
  taskList: any = [];
  taskName: any;
  selectedProjectId: any;
  selectedTaskId: any;
  currentIndex: number = 1;
  filteredData: any = [];
  balanceRecords: number = 0;
  searchKey: string = '';
  statuses = ['rejected', 'failed', 'completed', 'canceled', 'Unavailable', 'archived'];
  customTooltipColumns: string[] = [];
  customTooltipColumnsSR: string[] = [];
  customTooltipColumns1: any[] = ['Signal', 'Collection Duration', 'Cost', 'Audio', 'Audio Cost']
  timezone: string = 'UTC';
  noTaskCreatePermission: boolean = false;
  rule: string;
  iscueing: boolean;
  tipAndCueBasedOn: string;
  isFeedsAvailable: boolean;
  mlTasks = [];
  allMlTasks: any[] = [];
  selectedCatalogData: Map<string, any[]> = new Map()
  public indicesDeliveryTime = INDICES_DELIVERY_TIME;
  isbanneropen: boolean = false;
  isFeedDisplay: boolean = true;

  constructor(
    private matdialog: MatDialog,
    private authService: AuthService,
    private taskService: TaskService,
    private router: Router,
    private apiService: ApiService,
    private toastService: ToasterService,
    private userService: UserService,
    private popupService: PopupService,
    private dataService: DataService,
    private sessionTracker: SessionTrackerService,
    private utilsService: UtilsService,
    private posthogService: PosthogService
  ) {
    this.dataService.darkTheme.subscribe((newValue) => {
      this.darkTheme = newValue;

      this.tooltipImagePath = this.darkTheme ? '../../../assets/images/union-dark.svg' : '../../../assets/images/union.svg';
      this.orbitImage = this.darkTheme ? '../../../assets/images/orbit-dark.png' : '../../../assets/images/orbit.png';
    });

    this.authService.getCurrentUser();
    const castUser = this.authService.castCurrentUser.subscribe(
      async (res: any) => {
        this.currentUser = await res;
        this.setCustomTooltipColumns();
        this.setCustomTooltipColumns1();
        if (this.currentUser?.verified) {
          let userSubs = 'standard';
          this.userService
            .getSensorsPolicy(userSubs, this.currentUser?.id)
            .subscribe((res: any) => {
              this.cancelPolicy = res;
            });
          this.userid = this.currentUser.id;
          if (this.currentUser.userType === 'admin')
            this.userid = this.userid + 'admin';
          this.tasktabs = TASKTABS;
          this.curOption = -1;
          this.getTaskdata(this.userid);
          this.getCartDataVal(this.userid);
        } else {
          this.authService.logoutAndReset();
        }
        castUser.unsubscribe();
        this.loadUserDetails(this.currentUser?.id);
      }
    );

    if (environment.demoView === 'true') {
      this.demoView = true;
    } else {
      this.demoView = false;
    }
    this.OPERATORS = OPERATORS;
    localStorage.removeItem('taskData');
    this.dataService.clearSelectedSensors();
  }

  @ViewChild(MatSort) sort: MatSort;

  onCheck() {
    this.check = !this.check;
  }
  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }
  ngOnInit(): void { }

  loadUserDetails(userId): void {
    if (userId) {
      this.userService.personalInfo(userId).subscribe({
        next: (res: any) => {
          this.currentUser = res;
          this.setCustomTooltipColumns();
          this.setCustomTooltipColumns1();
          this.allocated = this.currentUser?.allocated;
          this.noTaskCreatePermission = (this.currentUser?.permission_based && this.currentUser?.userType != 'Super user' &&
            (!this.currentUser.permissions.includes(1)) || !this.currentUser?.user_enabled);

          if (this.currentUser?.permission_based) {
            this.updateInnerNameDisplay('permission_based');
          }
        },
        error: (error) => {
        }
      });
    }
  }

  getCartDataVal(userId: any) {
    if (this.currentUser?.id) {
      this.apiService.cartdata(this.currentUser.id);
      const res = this.apiService.castCartData.subscribe((result: any) => {
        if (result?.length > 0) {
          this.CARTDATA = result;
        }
      });
      res.unsubscribe();
    }
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.searchKey = filterValue;
    if (!this.searchKey) {
      this.currentIndex = 1;
      this.filteredData = [];
      if (this.selectedProjectId || this.selectedTaskId) this.getData(this.selectedProjectId, this.selectedTaskId);
      else this.getTaskList();
    }
  }

  desktopVersion() {
    this.matdialog.open(DesktopVersionComponent, {
      maxWidth: '80%',
      backdropClass: 'blurred',
      disableClose: true,
    });
  }

  isExpansionDetailRow = (i: number, row: Object) => {
    return row.hasOwnProperty('position');
  };

  getTaskdata(userId: any) {
    if (this.currentUser?.id) {
      this.tableDataLength = 0;
      this.load = true;
      let tab = 'recent';
      if (this.demoView) {
        tab = 'tasklist';
        this.tabSelected = 'tasklist';
      }

      let taskParams = { userid: userId, tabSelected: tab, currentIndex: this.currentIndex }
      this.taskService.getTask(taskParams).subscribe(
        (result: any) => {
          this.load = false;
          for (const data of result.results) {
            if (data?.outcomeCheck) {
              data.request.length = 1;
            }

            if ((data?.taskStrategy === 'Tip-and-Cue' || data?.taskStrategy === 'Tip-and-Cue-Outcome') && data.request[0]?.sensorType === 'Cueing') {
              data.request = (data.request).reverse();
            }
          }
          this.getTaskStatus(result);
          this.getProjects();
        },
        (err) => {
          return false;
        }
      );

      this.apiService.getTaskCount(userId).subscribe((response: any) => {
        if (response?.result > 0) {
          this.allTask = true;
          this.taskLength = response?.result;
        }
      });
    }
  }

  getTask(result) {
    this.retaskDisable = !this.canRetaskProject(result);
  }

  private getTaskDisplayId(task): string {
    if (task?.taskStrategy === 'Feed Based') {
      return (
        task?.questionId
      );
    }

    return task?.id;
  }

  getTaskStatus(taskData: any) {
    for (const result of taskData.results) {
      result.retask = true;
      const uniqueStatus = result.request.every(item => item.status === result.request[0].status);
      if (uniqueStatus) {
        const sameStatus = result.request[0]?.status;
        if (sameStatus === 'completed') result.taskCompleted = true;
        else result.taskCompleted = false;

      } else {
        result.taskCompleted = false;
      }

      this.retaskDisable = !this.canRetaskProject(result);
      result.retask = !this.retaskDisable;

      let green = 0, yellow = 0, red = 0;
      for (const item of result.request) {
        const checkstatus = this.statusCount(item?.status);
        if (checkstatus === 'done') green += 1;
        if (checkstatus === 'wip') yellow += 1;
        if (checkstatus === 'canceled' || checkstatus === 'Unavailable') red += 1;
      }
      result.greenCount = green;
      result.yellowCount = yellow;
      result.redCount = red;

      const convertedDates = this.convertDateAndTimes(result);

      result.submissionDate = convertedDates.submissionDate;
      result.startDate = convertedDates.startDate;
      result.endDate = convertedDates.endDate;
      result.hasExpired = new Date(result.endDate).getTime() < this.todayDate.getTime() ? true : false;
      for (const item of result.request) {
        const convertedDates = this.convertDateAndTimes(item);

        if (item.firstCapture) item.firstCaptureTime = convertedDates.firstCaptureTime;
        if (item.lastCapture) item.lastCaptureTime = convertedDates.lastCaptureTime;
      }
    }
    this.balanceRecords = taskData.balance;
    this.filteredData = this.filteredData.concat(taskData.results);

    this.dataSource = new MatTableDataSource<any>(this.filteredData);
    this.tableDataLength = this.filteredData.length > 0 ? this.filteredData.length : 0;
    this.taskData = this.filteredData.length > 0 ? this.filteredData : [];
  }

  onItemChange(value: any) {
    this.filterName = '';
    this.tableDataLength = 0;
    this.tabSelected = value.id;
    let tabType = value.id;
    this.searchKey = '';

    this.taskName = '';
    this.projectName = '';
    this.selectedProjectId = '';
    this.selectedTaskId = '';
    this.taskList = [];
    this.currentIndex = 1;
    this.filteredData = [];
    this.selectedTasks = []

    if (value.id === 'all' || (value.id === 'recent' && this.demoView)) {
      tabType = 'tasklist';
      this.tabSelected = 'tasklist';
    }
    this.load = true;
    if (tabType !== 'recent') {
      this.allTask = false;
    } else if (this.taskLength > 0) {
      this.allTask = true;
    }

    this.getProjects();
    this.cancelPendingRequests.next();
    let taskParams = { userid: this.userid, tabSelected: tabType, currentIndex: this.currentIndex };
    const currentRequestId = ++this.latestRequestId;

    this.taskService.getTask(taskParams)
      .pipe(takeUntil(this.cancelPendingRequests))
      .subscribe((result: any) => {
        // Check if this response is from the latest request
        if (currentRequestId !== this.latestRequestId) {
          return;
        }
        this.load = false;
        for (const data of result.results) {
          if (data?.outcomeCheck) {
            data.request.length = 1;
          }
          if ((data?.taskStrategy === 'Tip-and-Cue' || data?.taskStrategy === 'Tip-and-Cue-Outcome') && data.request[0]?.sensorType === 'Cueing') {
            data.request = (data.request).reverse();
          }
        }
        this.getTaskStatus(result);
      }, (err) => {
        return false;
      });
  }

  announceSortChange(sort: Sort) {
    const data = this.taskData.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'position':
          return this.compare(a.project, b.project, isAsc);
        case 'taskname':
          return this.compare(a.taskname, b.taskname, isAsc);
        case 'createddate':
          return this.compare(a.createddate, b.createddate, isAsc);
        case 'startdue':
          return this.compare(a.startdue, b.startdue, isAsc);
        case 'enddue':
          return this.compare(a.enddue, b.enddue, isAsc);
        case 'taskcost':
          return this.compare(a.taskcost, b.taskcost, isAsc);
        case 'frequency':
          return this.compare(a.frequency, b.frequency, isAsc);
        case 'repeatfrequency':
          return this.compare(a.repeatfrequency, b.repeatfrequency, isAsc);

        default:
          return 0;
      }
    });
    this.dataSource = new MatTableDataSource<any>(this.sortedData);
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  OpenPopup(e: any) {
    let observationLocation:any = false;
    if (e?.observation?.length > 0 && e?.observation[0]?.data_type === 'location') {
      observationLocation = e.observation[0].observationValue;
    }
    if (e.greenCount > 0 || e.yellowCount > 0 || e?.outcomeCheck) {
      this.matdialog.open(LeafletNewpreviewComponent, {
        width: '50%',
        data: { taskid: e.id, taskname: e.taskname, target: e.target, sensors: e.request,
          targetPoints: e?.targetPoints, type: 'taskPreview', observationLocation: observationLocation, questionId: e?.questionId
         },
        backdropClass: 'blurred',
        disableClose: true,
      });
    }
  }

  toggleRow(row: any) {
    if(row.taskStrategy === 'Feed Based') {
      this.updateInnerNameDisplay('Feed Based');
    } else{
       this.updateInnerNameDisplay();
    }
   let sensorArray:any[] = []
      this.resolutionColumn = 'Resolution';
    if (this.expandedElement === row.id) {
      this.expandedElement = null;
    } else {
      this.allMlTasks = [];
      this.FeedsAvailabilityCheck(row)
      this.expandedElement = row.id;
       sensorArray = row.request?.map((req: any) => req.sensor) || [];
       if (sensorArray.length === 1 && sensorArray.includes('RF')) {
      this.resolutionColumn = 'RF Service';
    } else if (sensorArray.length > 1 && sensorArray.includes('RF')) {
      this.resolutionColumn = 'Resolution/RF Service';
    }
    }
  }

  cancelTask(e: any, index: any, type: any) {
    const items = e.request;
    const filteredItems = items.filter(item => item.checked === true && item.orderStatus === 'ordered');
    const hasPayTrue = filteredItems.some(item => item.pay === true);
    const hasPayFalse = filteredItems.some(item => item.pay === false || item.pay === undefined);
    const nonOrderedSensors = items.filter(item => item.checked === true && (item.status === 'awaiting' ||
      item.status === 'approved' || item.status === 'pending approval'
    ));
    const orderedSensors = items.filter(item => item.checked === true && (item.status === 'ordered' ||
      item.status === 'delivering'
    ));
    const currentDate = new Date();
    const lastCaptureEnd = orderedSensors.filter(orderedSensor =>
      orderedSensor.operatorKey === OPERATORS.USL &&
      orderedSensor.lastCapture &&
      new Date(orderedSensor.lastCapture).getTime() < currentDate.getTime()
    );
    const userIdMatch = orderedSensors.every(item => item.ordered_by === this.currentUser.id); // checking for userId with orderedUserId
    const hasReqSent = filteredItems.some(item => item?.cancel_requested);

    if (this.currentUser?.permission_based && this.currentUser?.userType != 'Super user') {
      if ((nonOrderedSensors?.length > 0 && (this.currentUser.id != e.customerid)) || 
      (orderedSensors?.length > 0 && !this.currentUser?.permissions.includes(4) && !this.currentUser?.permissions.includes(3))) {
        const message = 'You do not have permission to cancel this sensor';
        this.popupService.openPopup(CollectionPopupComponent, message, '', '50%');
        return
      }

     if (orderedSensors?.length > 0 && !this.currentUser?.permissions.includes(4) &&
         this.currentUser?.permissions.includes(3) && hasReqSent) {
      const message = 'The cancel request has already been submitted and is being reviewed';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '50%');
      return
    }
    }

    if (hasPayTrue && hasPayFalse) {
      const message = 'One or more tasks you are trying to cancel is a Pay Later (invoice-based) task. You may only cancel it/them independently and not combine with tasks paid with other payment methods.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '50%');
      return
    }
    
    if (lastCaptureEnd.length > 0) {
      const message = "Your task is already in progress. You can't cancel task.";
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return
    }

    if (this.tabSelected === 'all') {
      this.tabSelected = 'tasklist';
    }

    e.request.forEach((row) => {
      if (
        (row?.orderStatus === 'ordered' || row?.orderStatus === 'delivering') &&
        row?.checked
      ) {
        type = 'task';
      }
    });

    const dialogRef = this.matdialog.open(CancelsensorComponent, {
      backdropClass: 'blurred',
      disableClose: true,
      data: {
        taskaction: 'taskcancel',
        user: this.currentUser,
        task: e,
        index,
        type,
      },
      maxWidth: '50%',
      minWidth: '35%'
    });
    const indx = this.taskData.findIndex((task) => task.id === e.id);

    dialogRef.afterClosed().subscribe((result) => {
      this.selectedCost = 0;
      (this.selectedTasks = []), (this.selectedSensors = []);
      const indx = this.taskData.findIndex((task) => task.id === e.id);
      this.currentIndex = 1;
      this.filteredData = [];

      if (result?.msg === 'Success' || result === 'Success' || result?.message === 'Task Cancel Requested') {
        if (!this.selectedProjectId && !this.selectedTaskId) {
          this.getTaskList();
        } else {
          this.getData(this.selectedProjectId, this.selectedTaskId);
        }

        this.expandedElement = e.id;

        if (type === 'task') {
          const dialogRef = this.matdialog.open(CancelinvoiceComponent, {
            width: '50%',
            backdropClass: 'blurred',
            disableClose: true,
            data: { taskname: e.taskname, taskStrategy: e.taskStrategy },
          });
        }
      } else if (result === 'Failed') {
        const message = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
        this.popupService.openPopup(CollectionPopupComponent, message, '', '50%');
      }
      else {
        this.taskData[indx].request.forEach((oprtr) => {
          oprtr.checked = false;
        });
      }
      this.dataSource = new MatTableDataSource(this.taskData);
      this.dataSource.sort = this.sort;
    });
  }

  taskStatus(e: any, index: number) {
    let operators: any = [];
    e.request.filteredData.forEach((oprtr) => {
      let isOk = this.isTrue(index, oprtr.status);
      if (isOk && index === 999) {
        if (oprtr.status !== 'rejected') oprtr.checked = true;
      }
      if ((oprtr.taskid && isOk) || oprtr.status === 'awaiting') {
        const operator = oprtr.name,
          taskid = oprtr.taskid,
          sensor = oprtr.sensor,
          resolution = oprtr.resolution;
        operators.push({ operator, taskid, sensor, resolution });
      }
    });

    const taskBody = { taskid: e.id, operators: operators };
  }

  taskOrderStatus(e: any, index: number) {
    let operators: any = [];
    e.request.filteredData.forEach((oprtr) => {
      let isOk = this.isTrue(index, oprtr.status);
      if (isOk && index === 999) {
        if (oprtr.status !== 'rejected') oprtr.checked = true;
      }
      if ((oprtr.taskid && isOk) || oprtr.status === 'awaiting') {
        const operator = oprtr.name,
          taskid = oprtr.taskid,
          sensor = oprtr.sensor,
          resolution = oprtr.resolution;
        operators.push({ operator, taskid, sensor, resolution });
      }
    });

    const taskBody = { taskid: e.id, operators: operators };
  }

  isTrue(id: number, status) {
    if (
      status === undefined ||
      status === '' ||
      status === 'canceled' ||
      status === 'rejected' ||
      status === 'awaiting'
    ) {
      return false;
    } else return true;
  }

  formatTaskArea(x: number, y: number): string {
    if (x > y) {
      return `${x}`;
    } else {
      return `${x} (${y.toFixed(2)})`;
    }
  }

  async checkout(el: any, index: any) {
    el.save4later = false;
    this.umbra = false;
    this.noFeasibilty = false;
    this.satellogic = false;
    this.operators = [];
    const endDate = new Date(el.closeWindow);
    const startDate = new Date(el.openWindow);
    const currentDate = new Date();
    this.head = false;
    let checkTime = false;

    el.request.forEach((val) => {
      let approveTime: any;
      let timeDifference = 0, twelveHoursInMillis = 0;

      if (val?.approveTime) {
        approveTime = new Date(val.approveTime);
        timeDifference = currentDate.getTime() - approveTime.getTime();
        twelveHoursInMillis = 12 * 60 * 60 * 1000;
        checkTime = true;
      }

      if (
        val.checked &&
        val.feasibility &&
        (!val?.opportunities || val?.opportunities === 'close')
      ) {
        this.noFeasibilty = true;
      } else if (val.checked && val.operatorKey === OPERATORS.UMBRA) {
        this.umbra = true;
      } else if (val.checked && checkTime && val.operatorKey === OPERATORS.HEAD && timeDifference >= twelveHoursInMillis) {
        this.head = true;
      }
    });
    if (endDate.getTime() < currentDate.getTime()) {
      const indx = this.taskData.findIndex((task) => task.id === el.id);
      const dialogRef = this.matdialog.open(ToiWarningPopupComponent, {
        width: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: { message: 'toi', row: el.request, user: this.currentUser },
      });
    } else if (startDate.getTime() < currentDate.getTime() && this.umbra) {
      const indx = this.taskData.findIndex((task) => task.id === el.id);
      const dialogRef = this.matdialog.open(ToiWarningPopupComponent, {
        width: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: { message: 'umbra', row: el.request, user: this.currentUser },
      });
      dialogRef.afterClosed().subscribe(async (result) => {
        el.request.forEach((val) => {
          if (val.operatorKey === OPERATORS.UMBRA) {
            val.checked = false;
          }
        });
        const checkedSensors = el.request.filter(sensor => sensor.checked === true);
        if (checkedSensors.length === 0) {
          this.selectedSensors.length = 0;
          this.selectedTasks.length = 0;
        }
      });

    } else if (this.noFeasibilty) {
      const indx = this.taskData.findIndex((task) => task.id === el.id);
      const dialogRef = this.matdialog.open(ToiWarningPopupComponent, {
        width: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: { message: 'feasibility', row: el.request, user: this.currentUser },
      });
      dialogRef.afterClosed().subscribe(async (result) => {
        this.OpenOpportunities(index, this.taskData[indx])
      });
    } else if (this.head) {
      const dialogRef = this.matdialog.open(ToiWarningPopupComponent, {
        width: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: { message: 'head', row: el.request, user: this.currentUser }
      });
    } else {
      el.request.forEach((val) => {
        if (val.operatorKey !== OPERATORS.SPIRE && val.operatorKey !== OPERATORS.CLYDE
          && val.operatorKey !== OPERATORS.LBAND
        ) {
          if (
            (!el?.target.includes('Point') || el?.frequency === 1) &&
            val.checked) {
            this.satellogic = true;
            const operator = val.name,
              taskid = val.taskid,
              sensor = val.sensor,
              resolution = val.resolution,
              status =
                val.status === 'Ordered' ||
                val.orderStatus === 'ordered' ||
                val.status === '100',
              uuid = val.uuid,
              type = val?.type,
              operatorKey = val?.operatorKey,
              latency = val?.latency;
            this.operators.push({
              operator,
              taskid,
              sensor,
              resolution,
              uuid,
              status,
              latency,
              type,
              operatorKey,
            });
          }
        }
      });

      if (this.satellogic) {
        const dialogRef = this.matdialog.open(CancelpaylaterComponent, {
          width: '50%',
          backdropClass: 'blurred',
          disableClose: true,
          data: { satellogic: this.satellogic },
        });
        dialogRef.afterClosed().subscribe(async (result) => {
          if (result === 'yes') {
            const indx = this.taskData.findIndex((task) => task.id === el.id);
            const checkedItems = this.taskData[indx].request.filter(item => item.checked);
            const isISTask = this.taskData[indx].isISTask;

            let selectedSensors: any = [];
            checkedItems.forEach(item => {
              selectedSensors.push({
                sensor: item.sensor,
                name: item.name,
                resolution: item?.originalResolution,
                imaging_mode: item?.collectionMode[0]?.key ?? null,
                polarization: item?.sarPolarization ?? null
              });
            });
            try {
              let isAdded = await this.addToCart(el, 'order');
              if (isAdded) {
                this.dataService.setSelectedSensors(this.selectedSensors);
                this.router.navigate(['/payment'], {
                  queryParams: { taskId: el.id, type: 'task' },
                });
              }
            } catch (error) {
              console.error("Error adding to cart:", error);
            }
          } else if (result === 'no') {
            const action = 'taskcancel';
            this.selectedTasks.length = 0;
            this.selectedSensors.length = 0;
            const taskBody = { taskid: el.id, operators: this.operators };
            const res = await this.apiService
              .cancelSensor(action, taskBody)
              .subscribe((res: any) => { });
            this.apiService.deleteSensor(taskBody).subscribe((res: any) => { });
            const indx = this.taskData.findIndex((task) => task.id === el.id);
            this.selectedCost = 0;
            let completed = 0,
              wip = 0,
              canceled = 0;

            this.taskData[indx].request.forEach((sensor, i = index) => {
              if (sensor.checked) {
                this.taskData[indx].request[i].status = 'canceled';
                this.taskData[indx].request[i].checked = false;
              }
              const chkstatus = this.statusCount(
                this.taskData[indx].request[i].status
              );
              if (chkstatus === 'done') completed += 1;
              if (chkstatus === 'wip') wip += 1;
              if (chkstatus === 'canceled') canceled += 1;
            });
            this.taskData[indx].completed = completed;
            this.taskData[indx].wip = wip;
            this.taskData[indx].canceled = canceled;
            this.dataSource = new MatTableDataSource(this.taskData);
            this.dataSource.sort = this.sort;
          }
        });
      } else {
        //here
        const indx = this.taskData.findIndex((task) => task.id === el.id);
        const checkedItems = this.taskData[indx].request.filter(item => item.checked);
        const isISTask = this.taskData[indx].isISTask

        let selectedSensors: any = [];
        checkedItems.forEach(item => {
          selectedSensors.push({
            sensor: item.sensor,
            name: item.name,
            resolution: item?.originalResolution,
            imaging_mode: item?.collectionMode[0]?.key ?? null,
            polarization: item?.sarPolarization ?? null
          });
        });
        try {
          let isAdded = await this.addToCart(el, 'order');
          if (isAdded) {
            this.dataService.setSelectedSensors(this.selectedSensors);
            this.router.navigate(['/payment'], {
              queryParams: { taskId: el.id, type: 'task' },
            });
          }
        } catch (error) {
          console.error("Error adding to cart:", error);
        }

      }
    }
  }

  async addToCart(task: any, type: any): Promise<boolean> {
    const endDate = new Date(task.closeWindow);
    const currentDate = new Date();
    this.noFeasibilty = false;
    this.head = false;
    let checkTime = false;

    let approveTime: any;
    let timeDifference = 0, twelveHoursInMillis = 0;
    task.request.forEach(val => {
      if (val?.approveTime) {
        approveTime = new Date(val.approveTime);
        timeDifference = currentDate.getTime() - approveTime.getTime();
        twelveHoursInMillis = 12 * 60 * 60 * 1000;
        checkTime = true;
      }
      if (val.checked && checkTime && val.operatorKey === OPERATORS.HEAD && timeDifference >= twelveHoursInMillis) {
        this.head = true;
      }
    });

    if (endDate.getTime() < currentDate.getTime()) {
      const indx = this.taskData.findIndex((task) => task.id === task.id);
      this.matdialog.open(ToiWarningPopupComponent, {
        width: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: { message: 'toi', row: task.request, user: this.currentUser }
      });
      return false;
    } else if (this.head) {
      this.matdialog.open(ToiWarningPopupComponent, {
        width: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: { message: 'head', row: task.request, user: this.currentUser }
      });
      return false;
    } else {
      let selectedSensorTypes: any = [];
      this.selectedSensors.forEach(item => {
        selectedSensorTypes.push({
          sensor: item.sensor,
          name: item.name,
          resolution: item?.originalResolution,
          sensorId: item.uuid
        });
      });
      let isOpenWater = task.openWater ? true : false;

      const newcartdata = [];
      let taskcost = 0;
      this.selectedSensors = [];

      try {
        const result: any = this.currentUser?.user_plan === 1
          ? { msg: 'Success', informationServices: [] }
          : await lastValueFrom(this.apiService.getInformationServices(selectedSensorTypes, task.id, isOpenWater));

        if (result.msg === 'Success') {
          this.load = false;
          const informationServices = result.informationServices;
          this.mlTasks = informationServices.filter((item) => item.isChecked);
           newcartdata['customerid'] = this.currentUser.id;
          newcartdata['taskid'] = task.id;
          newcartdata['project'] = task.project;
          newcartdata['taskname'] = task.taskname;
          newcartdata['target'] = task.target;
          newcartdata['openWindow'] = task.openWindow;
          newcartdata['closeWindow'] = task.closeWindow;
          newcartdata['checked'] = true;
          newcartdata['taskFrequency'] = task?.frequency;
          const combinedTasks: any[] = [];
          const allSavedCatalogs: any[] = [];

        for (const sensor of selectedSensorTypes) {
          const storageKey = `catalogData_task_${task.id}_sensor_${sensor.sensorId}`;
          const savedData = localStorage.getItem(storageKey);

          try {
            const parsed = savedData ? JSON.parse(savedData) : [];
            allSavedCatalogs.push(...parsed);
          } catch (error) {
            console.error("Error parsing saved catalog for sensor:", sensor.sensorId, error);
          }
        }

        const mergedTasks = [...(allSavedCatalogs ?? [])];

        (this.mlTasks ?? []).forEach((mlTask: any) => {
          const exists = mergedTasks.some(
            (t: any) =>
              t?._id && mlTask?._id &&
              t?.sensorId && mlTask?.sensorId &&
              t._id === mlTask._id &&
              t.sensorId === mlTask.sensorId
          );

          if (!exists) mergedTasks.push(mlTask);
        });

        const checkedTasks = mergedTasks.filter((t: any) => t.isChecked === true);

        combinedTasks.push(...checkedTasks);
        newcartdata["mlTasks"] = combinedTasks;

          task.request.forEach((sensor) => {
            if (sensor.checked) {
              this.selectedSensors.push(sensor);
              let c = 0;
              
              if (sensor?.super_resolution) {
                c = parseFloat((sensor?.super_resolution[0] || []).totalareacost) ?? 0;
              }
              taskcost += sensor.cost + c;
            }
          });
          this.selectedSensors.forEach(el => {
            if (el?.valueAddedOption) {
              let totalSum = 0;
              Object.keys(el.valueAddedOption).forEach(key => {
                if (Array.isArray(el.valueAddedOption[key])) {
                  el.valueAddedOption[key].forEach(item => {
                    totalSum += item.totalareacost || 0;
                  });
                }
              });
              el.demTotalPrice = totalSum;
            }
        }); 
          newcartdata['cartdata'] = this.selectedSensors;
          newcartdata['taskcost'] = taskcost;
          newcartdata['totalVaoCost'] = task?.totalVaoCost ?? 0;
          newcartdata['totalSRPCost'] = task?.totalSRPCost ?? 0;
          newcartdata['feasibilityTask'] = task?.feasibilityTask;
          newcartdata['taskStrategy'] = task?.taskStrategy;
          newcartdata['purpose'] = task?.purpose;
          newcartdata['intent'] = task?.intent?.intent_key ? task?.intent?.intent_key : task?.intent;
          newcartdata['repeatFrequency'] = task?.repeatFrequency;
          newcartdata['noOfRepeats'] = task?.noOfRepeats;
          newcartdata['subDailyCount'] = task?.subDailyCount;
          newcartdata['projectid'] = task?.projectid;
          newcartdata['openWater'] = task?.openWater;
          newcartdata['tipAndCueBasedOn'] = task?.tipAndCueBasedOn;

          const res: any = await lastValueFrom(this.apiService.addToCart(this.currentUser.id, newcartdata));
          const displayTaskId = this.getTaskDisplayId(task);

          if (type === 'cart') {
            if (res.Msg === 'saved') {
              const toast: any = {
                type: 'success',
                title: '',
                msg: `Task ${displayTaskId} is added in your cart`,
              };
              this.toastService.openSnackBar(toast, 'Show My Cart');
            } else if (res.Msg === 'updated') {
              const toast: any = {
                type: 'success',
                title: '',
                msg: `Task ${displayTaskId} is updated in your cart.`,
              };
              this.toastService.openSnackBar(toast, 'Ok');
            } else if (res.Msg === 'duplication') {
              const toast: any = {
                type: 'warning',
                title: '',
                msg: `Task ${displayTaskId}  already exists in your cart.`,
              };
              this.toastService.openSnackBar(toast, 'Show My Cart');
            }
          }
          return true;
        } else {
          throw new Error('Failed to retrieve information services');
        }
      } catch (error) {
        return false;
      }
    }
  }

  selectedTask2Cart(el: any) {
    const newcartdata = [];
    let taskcost = 0;
    this.selectedSensors = [];
    this.CARTDATA = [];
    newcartdata['customerid'] = this.currentUser.id;
    newcartdata['taskid'] = el.id;
    newcartdata['project'] = el.project;
    newcartdata['taskname'] = el.taskname;
    newcartdata['target'] = el.target;
    newcartdata['openWindow'] = el.openWindow;
    newcartdata['closeWindow'] = el.closeWindow;
    newcartdata['checked'] = true;
    newcartdata['taskFrequency'] = el?.frequency;
    newcartdata['mlTasks'] = el?.mlTasks;
    // newcartdata['isISTask'] = el?.isISTask;
    if (this.CARTDATA && this.CARTDATA.length > 0)
      this.CARTDATA.forEach((task, index) => {
        this.CARTDATA[index].checked = false;
      });
    el.request.forEach((sensor) => {
      if (sensor.checked) {
        this.selectedSensors.push(sensor);
        let c = 0;
        if (sensor?.super_resolution) {
          c = parseFloat((sensor?.super_resolution[0] || []).totalareacost) ?? 0;
        }
        taskcost += sensor.cost + c;
      }
    });
    this.selectedSensors.forEach(el => {
      if (el?.valueAddedOption) {
        let totalSum = 0;
        Object.keys(el.valueAddedOption).forEach(key => {
          if (Array.isArray(el.valueAddedOption[key])) {
            el.valueAddedOption[key].forEach(item => {
              totalSum += item.totalareacost || 0;
            });
          }
        });
        el.demTotalPrice = totalSum;
      }
    });

    newcartdata['cartdata'] = this.selectedSensors;
    newcartdata['taskcost'] = taskcost;
    newcartdata['totalVaoCost'] = el?.totalVaoCost ?? 0;
    newcartdata['totalSRPCost'] = el?.totalSRPCost ?? 0;
    this.CARTDATA.push(newcartdata);
    this.apiService.updateCartDB(this.currentUser.id, newcartdata);
    this.apiService.cartBS.next(this.CARTDATA);
  }

  getTaskCost(checked: boolean, el: any, i: any) {
    (this.selectedCost = 0),
      ((this.selectedSensors = []),
        (this.selectedTasks = []),
        (this.order = false),
        (this.cancelFeasibility = true));
    el.request[i].checked = checked;
    el.request.forEach((row) => {
      if (row.checked) {
        if (
          row?.orderStatus === 'ordered' ||
          row.status === 'awaiting' ||
          row.status === 'delivering'
        ) {
          this.order = true;
        }
        this.selectedCost += row.cost;
        this.selectedTasks.push(row);
        this.rule = el?.rule;
        this.iscueing = el.request.some(
          (item: any) => item.checked == true && item.sensorType?.toLowerCase() === 'cueing'
        );
        this.tipAndCueBasedOn = el.tipAndCueBasedOn;
      }
    });

    for (const row of this.selectedTasks) {
      if (
        (row?.orderStatus === 'ordered' || row.status === 'ordered') &&
        row?.operatorKey === OPERATORS.AXELSPACE
      ) {
        this.cancelFeasibility = false;
      } else this.cancelFeasibility = true;
    }

    el.request.forEach((row) => {
      if (
        row.checked &&
        !this.order &&
        row?.orderStatus != 'ordered' &&
        row.status !== 'awaiting' &&
        row.status !== 'delivering' &&
        row.status !== 'archived' &&
        row.status !== 'restored'
      ) {
        this.selectedSensors.push(row);
      }
    });
    const orderPendingCount = this.selectedSensors.filter(item => (item.status === 'pending' ||
      item.status === 'pending approval'
    )).length;
    this.orderPending = !!orderPendingCount;
  }

  deselect(e) {
    this.selectedCost = 0;
    this.selectedTasks = [];
    this.selectedSensors = [];
    this.order = false;
    const indx = this.taskData.findIndex((task) => task.id === e.id);
    this.taskData[indx].request.forEach((oprtr) => {
      oprtr.checked = false;
      if (oprtr.signalOfInterest) {
        const hasAudioSignal = oprtr.signalOfInterest.some(signal => signal.isAudio === true);
        oprtr.isAudio = hasAudioSignal;
      }
    });
  }

  go2Route(id: any) {
    this.NAVLISTRT.forEach((item, index) => {
      if (id === index) {
        this.NAVLISTRT[index].active = true;
      } else {
        this.NAVLISTRT[index].active = false;
      }
    });
    this.router.navigate([this.NAVLISTRT[id].url]);
  }

  selections(element: any) {
    this.tooltipDisabled = false;
    if (element.operatorKey === OPERATORS.SPIRE) {
      this.detailsText = 'No cancelation is permitted once refresh is ordered'
    } else if (element.operatorKey === OPERATORS.CLYDE) {
      this.detailsText = "The sensor can be canceled anytime after two months with one month's" + '\n' + "notice on the minimum subscription of three months. Similarly," + '\n' + "all subscriptions require one month's notice.";
    } else {
      for (var i = 0; i < this.cancelPolicy.length; i++) {
        if (
          element.operatorKey === this.cancelPolicy[i].key &&
          element.sensor === this.cancelPolicy[i].sensor
        ) {
          this.policy = this.cancelPolicy[i].cancel_policy;
          this.policy.forEach((d) => {
            this.detailsText += 'Cancelation ' + d.key + ' : ' + d.value + '\n';
          });
        }
      }
    }
  }

  onMouseOut() {
    this.tooltipDisabled = true;
    this.detailsText = ' ';
  }

  OpenFeasibilty(element: any, index: any, task: any) {
    if (task?.hasExpired) {
      return;
    }
    const dialog = this.matdialog.open(FeasibilityComponent, {
      minWidth: '68%',
      data: {
        row: element,
        user: this.userid,
        taskid: task.id,
        taskList: task,
        currentUser: this.currentUser,
        timezone: this.timezone
      },
      backdropClass: 'blurred',
      disableClose: true,
    });

    const indx = this.taskData.findIndex((elem) => elem.id === task.id);
    if (this.tabSelected === 'all') {
      this.tabSelected = 'tasklist';
    }

    dialog.afterClosed().subscribe((result) => {
      if (result != 'close') {
        this.taskData[indx].request[index].opportunities = result;
        if (element?.operatorKey === OPERATORS.AXELSPACE) {
          this.apiService
            .getFeasibilityCost(this.userid, result, task.id, element)
            .subscribe((result: any) => {
              this.taskData[indx].request[index].cost = result?.sensorCost;
              this.taskData[indx].taskcost = result?.totalCost;
            });
        }
        this.apiService.saveOpportunity(this.userid, task.id, [element]).subscribe(
          (result: any) => {
            if (result.msg === 'Success') {
              this.taskData[indx].request[index].firstCapture = result?.captures[0].firstCapture;
              this.taskData[indx].request[index].lastCapture = result?.captures[0].lastCapture;

              const convertedDates = this.convertDateAndTimes(result?.captures[0]);

              this.taskData[indx].request[index].firstCaptureTime = convertedDates.firstCaptureTime;
              this.taskData[indx].request[index].lastCaptureTime = convertedDates.lastCaptureTime;

            }
          },
          (err) => {
            return false;
          }
        );
      } else {
        this.currentIndex = 1;
        this.filteredData = [];
        if (!this.selectedProjectId && !this.selectedTaskId) {
          this.getTaskList();
        } else {
          this.getData(this.selectedProjectId, this.selectedTaskId);
        }

        this.expandedElement = task.id;
        this.selectedCost = 0;
        this.selectedTasks = [];
        this.selectedSensors = [];
      }
    });
  }

  cancelOpportunities(details) {
    this.operators = [];
    details.request.forEach((val) => {
      if (val.checked) {
        const operator = val.name,
          taskid = val.taskid,
          sensor = val.sensor,
          resolution = val.resolution,
          status =
            val.status === 'Ordered' ||
            val.orderStatus === 'ordered' ||
            val.status === '100',
          uuid = val.uuid,
          type = val?.type,
          operatorKey = val?.operatorKey,
          latency = val?.latency;
        this.operators.push({
          operator,
          taskid,
          sensor,
          resolution,
          uuid,
          status,
          latency,
          type,
          operatorKey,
        });
      }
    });

    const taskBody = { taskid: details.id, operators: this.operators };
    const dialog = this.matdialog.open(FeasibilityComponent, {
      minWidth: '68%',
      data: { task: details, taskBody: taskBody, currentUser: this.currentUser, timezone: this.timezone },
      backdropClass: 'blurred',
      disableClose: true,
    });
    dialog.afterClosed().subscribe((result) => {
      if (result.msg === 'Success') {
        this.currentIndex = 1;
        this.filteredData = [];
        if (!this.selectedProjectId && !this.selectedTaskId) {
          this.getTaskList();
        } else {
          this.getData(this.selectedProjectId, this.selectedTaskId);
        }

        this.expandedElement = details.id;
        this.selectedCost = 0;
        this.selectedTasks = [];
        this.selectedSensors = [];
      }
    });
  }

  getRetask(element: any) {
    const dialogRef = this.matdialog.open(RetaskOptionsDialogComponent, {
      width: '560px',
      backdropClass: 'blurred',
      disableClose: true,
      data: {
        darkTheme: this.darkTheme,
        taskName: element?.taskname,
        sensorName: element?.request?.[0]?.name,
      },
    });

    dialogRef.afterClosed().subscribe((retaskMode?: 'existing-sensor' | 'different-sensors') => {
      if (!retaskMode) {
        return;
      }

      const taskId = element?.taskId || element?.id;
      const sensorId = element?.uuid || element?.sensorId;

      const payload = {
        ...element,
        taskId,
        ...(sensorId ? { sensorId, uuid: sensorId } : {}),
        retaskSelectionMode: retaskMode,
      };

      this.dataService.setSelectedTask(JSON.stringify(payload));
      localStorage.setItem('rowData', JSON.stringify(payload));
      this.router.navigate(['/retask'], {
        queryParams: {
          ...(element?.taskStrategy === 'Feed Based' ? { mode: 'feed' } : {}),
          taskId,
          ...(sensorId ? { sensorId } : {}),
          option: retaskMode,
        },
      });
    });
  }

  canRetaskTask(task: any): boolean {
    if (!task || task?.outcomeCheck) {
      return false;
    }

    if (
      task?.taskStrategy === 'Task From Collection' ||
      task?.taskStrategy === 'Tip-and-Cue' ||
      task?.taskStrategy === 'Feed Based' ||
      task?.taskStrategy === 'Help Select Sensor(s)'
    ) {
      return false;
    }

    return true;
  }

  getProjectRetaskTooltip(task: any): string {
    if (this.noTaskCreatePermission) {
      return 'You do not have permission to create a re-task.';
    }

    if (this.canRetaskProject(task)) {
      return '';
    }

    return 'Task-level re-tasking is available only when every sensor request is in a terminal status and the original task used a user-initiated tasking strategy.';
  }

  canRetaskProject(task: any): boolean {
    if (!this.canRetaskTask(task)) {
      return false;
    }

    return Array.isArray(task?.request) &&
      task.request.length > 0 &&
      task.request.every((sensor: any) => this.statuses.includes(sensor?.status));
  }

  canRetaskSensor(task: any, sensor: any): boolean {
    if (!this.canRetaskTask(task) || !sensor) {
      return false;
    }

    return this.statuses.includes(sensor?.status);
  }

  getTaskRetaskTooltip(task: any, sensor: any): string {
    if (this.noTaskCreatePermission) {
      return 'You do not have permission to create a re-task.';
    }

    if (this.canRetaskSensor(task, sensor)) {
      return '';
    }

    return 'Sensor-level retasking is available only when a sensor request is in a terminal status and the original task used a user-initiated tasking strategy.';
  }

  getInnerNameDisplayColumns(detail: any): string[] {
    const hasMultipleSensorRows = Array.isArray(detail?.request) && detail.request.length > 1;

    return hasMultipleSensorRows
      ? this.innerNameDisplay
      : this.innerNameDisplay.filter((column) => column !== 'action');
  }

  getSensorRetaskPayload(task: any, sensor: any): any {
    if (!task || !sensor) {
      return task;
    }

    return {
      ...task,
      taskId: task?.id || task?.taskId,
      sensorId: sensor?.sensorId || sensor?.uuid,
      uuid: sensor?.uuid || sensor?.sensorId,
      request: [sensor],
    };
  }

  retaskSensor(task: any, sensor: any): void {
    if (!this.canRetaskSensor(task, sensor) || this.noTaskCreatePermission) {
      return;
    }

    this.getRetask(this.getSensorRetaskPayload(task, sensor));
  }

  getProjects() {
    this.apiService.getProjectList(this.tabSelected).subscribe((response: any) => {
      this.projectData = response.result;
    });
  }

  selectProject(projects: any) {
    this.projectName = projects?.project;
    this.selectedProjectId = projects?.projectid;
    this.taskName = '';
    this.selectedTaskId = '';
    this.currentIndex = 1;
    this.filteredData = [];
    this.getData(this.selectedProjectId, '');
    this.apiService.getTaskList(this.selectedProjectId, this.tabSelected).subscribe((response: any) => {
      this.taskList = response.result;
    });
  }

  selectTask(tasks: any) {
    this.taskName = tasks?.taskName;
    this.selectedTaskId = tasks?.id;
    this.currentIndex = 1;
    this.filteredData = [];
    this.getData(this.selectedProjectId, this.selectedTaskId);
  }

  toggleFilterPanel() {
    this.isFilterPanelExpanded = !this.isFilterPanelExpanded;
  }

  clearFilter() {
    this.taskName = '';
    this.projectName = '';
    this.selectedProjectId = '';
    this.selectedTaskId = '';
    this.currentIndex = 1;
    this.filteredData = [];
    this.getTaskList();
  }

  getData(projectId: any, taskId: any) {
    let taskParams = { projectId: projectId, tabSelected: this.tabSelected, taskId: taskId, currentIndex: this.currentIndex, searchKey: this.searchKey };
    this.apiService.getData(taskParams).subscribe((response: any) => {
      this.getTaskStatus(response);
    });
  }

  getTaskList() {
    let taskParams = { userid: this.userid, tabSelected: this.tabSelected, currentIndex: this.currentIndex, searchKey: this.searchKey };
    this.taskService.getTask(taskParams).subscribe(
      (result: any) => {
        this.load = false;
        for (const data of result.results) {
          if (data?.outcomeCheck) {
            data.request.length = 1;
          }
          if ((data?.taskStrategy === 'Tip-and-Cue' || data?.taskStrategy === 'Tip-and-Cue-Outcome') && data.request[0]?.sensorType === 'Cueing') {
            data.request = (data.request).reverse();
          }
        }
        this.getTaskStatus(result);
        this.taskList = [];
      },
      (err) => {
        return false;
      }
    );
  }

  getIsTooltipText(list: any[]) {
    this.isServices = '';
    if (list?.length > 0) {
      this.isServices = list?.reduce((acc, curr) => {
        acc = acc + curr.name + '\n';
        return acc;
      }, '');
    }
  }

  rateTask(task: any) {
    const index = this.taskData.findIndex((elem) => elem.id === task.id);
    const dialog = this.matdialog.open(StarRatingComponent, {
      width: '45%',
      data: { task: task, type: 'rating' },
      backdropClass: 'blurred',
      disableClose: true,
    });

    dialog.afterClosed().subscribe((result) => {
      if (result != 'close') {
        let feedbackObj = {
          rating: result.rating,
          feedback: result.feedback
        }
        this.taskData[index].feedback = feedbackObj;
      }
    });
  }

  handleButtonClick(event: Event) {
    event.stopPropagation();
  }

  loadMoreData() {
    if (this.balanceRecords > 0) {
      this.currentIndex += 1;
      if (!this.selectedProjectId && !this.selectedTaskId) this.getTaskList();
      else this.getData(this.selectedProjectId, this.selectedTaskId);
    }
  }

  statusCount(status: any) {
    if (status) {
      for (const key in STATUS_MAP) {
        if (status.includes(key)) {
          return STATUS_MAP[key];
        }
      }
    }
    return;
  }

  formatTooltip(element: any) {
    this.tooltipDisabled = false;
    element.forEach((data) => {
      this.detailsText += data + '\n';
    });
  }

  OpenOpportunities(index: any, task: any) {
    let selectedRows: any = [];
    let sensorDetails = task.request.filter(row => (row.checked));
    if (sensorDetails?.length === 1) {
      const checkedItemIndex = task.request.findIndex(row => row.checked);
      this.OpenFeasibilty(sensorDetails[0], checkedItemIndex, task);
    } else {

      const dialog = this.matdialog.open(OpportunityComponent, {
        minWidth: '68%',
        data: {
          user: this.userid,
          taskid: task.id,
          taskList: task,
          currentUser: this.currentUser,
          timezone: this.timezone
        },
        backdropClass: 'blurred',
        disableClose: true,
      });

      const indx = this.taskData.findIndex((elem) => elem.id === task.id);
      if (this.tabSelected === 'all') {
        this.tabSelected = 'tasklist';
      }

      dialog.afterClosed().subscribe((result) => {
        if (result != 'close') {
          let selectedOpportunities = result;
          selectedOpportunities.forEach((enteredRow) => {
            const correspondingRequest = this.taskData[indx].request.find(request => request.uuid === enteredRow.sensorDetail.uuid);
            if (correspondingRequest) {
              correspondingRequest.opportunities = enteredRow.enteredPreferences;
            }

            selectedRows.push(correspondingRequest);
          });

          if (selectedRows[0]?.operatorKey === OPERATORS.AXELSPACE) {
            this.apiService
              .getFeasibilityCost(this.userid, selectedOpportunities[0].enteredPreferences, task.id, selectedRows[0])
              .subscribe((result: any) => {
                selectedOpportunities.forEach((enteredRow) => {
                  const correspondingRequest = this.taskData[indx].request.find(request => request.uuid === enteredRow.sensorDetail.uuid);
                  if (correspondingRequest) {
                    correspondingRequest.cost = result?.sensorCost;
                    this.taskData[indx].taskcost = result?.totalCost;
                  }
                });
              });
          }
          this.apiService.saveOpportunity(this.userid, task.id, selectedRows).subscribe(
            (result: any) => {
              if (result.msg === 'Success') {
                result?.captures.forEach((enteredRow) => {
                  const correspondingRequest = this.taskData[indx].request.find(request => request.uuid === enteredRow.sensorId);
                  if (correspondingRequest) {
                    correspondingRequest.firstCapture = enteredRow.firstCapture;
                    correspondingRequest.lastCapture = enteredRow.lastCapture;

                    const convertedDates = this.convertDateAndTimes(enteredRow);

                    correspondingRequest.firstCaptureTime = convertedDates.firstCaptureTime;
                    correspondingRequest.lastCaptureTime = convertedDates.lastCaptureTime;
                  }
                });
              }
            },
            (err) => {
              return false;
            }
          );
        } else {
          this.currentIndex = 1;
          this.filteredData = [];
          if (!this.selectedProjectId && !this.selectedTaskId) {
            this.getTaskList();
          } else {
            this.getData(this.selectedProjectId, this.selectedTaskId);
          }

          this.expandedElement = task.id;
          this.selectedCost = 0;
          this.selectedTasks = [];
          this.selectedSensors = [];
        }
      });
    }
  }

hasValueAddedOptionKeys(obj:any)
{
  if(obj.valueAddedOption && Object.keys(obj.valueAddedOption).length > 0 || obj?.super_resolution?.length > 0 || obj?.indices?.length > 0) return true;
    return false;
  }
  setCustomTooltipColumns() {
    if (this.currentUser?.pointsEligible) {
      this.customTooltipColumns = ['actionProvider', 'sensorResolution', 'deliveryTime', 'point'];
      this.customTooltipColumnsSR = ['sensorResolution', 'deliveryTime', 'point'];
    } else {
      this.customTooltipColumns = ['actionProvider', 'sensorResolution', 'deliveryTime', 'cost'];
      this.customTooltipColumnsSR = ['sensorResolution', 'deliveryTime', 'cost'];
    }
  }

  setCustomTooltipColumns1() {
    if (this.currentUser.pointsEligible) {
      this.customTooltipColumns1 = ['Signal', 'Collection Duration', 'Point', 'Audio', 'Audio Point'];
    } else {
      this.customTooltipColumns1 = ['Signal', 'Collection Duration', 'Cost', 'Audio', 'Audio Cost']
    }
  }
  getDataRows(element: any) {
    const rows = Object.values(element?.valueAddedOption).flat();

    // Sort the rows array by actionProvider key, handling missing properties
    rows.sort((a, b) => {
      const actionA = (a as any).actionProvider || '';
      const actionB = (b as any).actionProvider || '';
      return actionA.localeCompare(actionB);
    });

    return [
      ...rows,
      ...(Array.isArray(element.super_resolution) ? element.super_resolution : []),
      ...(Array.isArray(element.indices) ? element.indices : [])
    ];
  }
  trackNewClick(source: 'desktop' | 'mobile') {
    const loginTimeStr = localStorage.getItem('loginTime');
    const logoutTime = new Date();
    let sessionDuration = 'Unknown';
    if (loginTimeStr) {
      const loginTime = new Date(loginTimeStr);
      const durationMs = logoutTime.getTime() - loginTime.getTime();
      const seconds = Math.floor((durationMs / 1000) % 60);
      const minutes = Math.floor((durationMs / (1000 * 60)) % 60);
      const hours = Math.floor(durationMs / (1000 * 60 * 60));
      sessionDuration = `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
    this.sessionTracker.startTracking();
    this.posthogService.capture('Enter-Tasking', {
      method: 'standard',
      message: `${this?.currentUser?.email} accessed the New Task page via  ${source} after ${sessionDuration} s.`,
      email: this?.currentUser?.email
    });

    const hasAnswerFirstFeature = this.utilsService.hasFeatureCheck(
      this.currentUser?.planDetails,
      ANSWER_FIRST
    );

    const isPermissionBasedUser = !!this.currentUser?.permission_based;
    const hasTaskCreatePermission = !!this.currentUser?.permissions?.includes(1);
    const hasFeedBasedTaskPermission = !!this.currentUser?.permissions?.includes(QUESTION_BASED_WORKFLOW);
    const hasTaskTypePermission = hasTaskCreatePermission || hasFeedBasedTaskPermission;

    const canUseTaskTypeModal = isPermissionBasedUser
      ? hasAnswerFirstFeature && hasTaskTypePermission
      : hasAnswerFirstFeature;

    if (canUseTaskTypeModal && !this.currentUser?.allocated && !this.currentUser?.cpc && !this.currentUser?.pointsEligible) {
    this.matdialog.open(TaskTypeModalComponent, {
     maxWidth: '80%',
     disableClose: true,
     backdropClass: 'blurred'
    })
   .afterClosed().subscribe(res => {
    if(res === 'close') return;

    if (this.currentUser?.permission_based && this.currentUser?.userType != 'Super user') {
      if (res === 'feed' && !hasFeedBasedTaskPermission) {
        this.popupService.openPopup(CollectionPopupComponent, 'You do not have permission to create a feed-based task.', '', '50%');
        return;
      }

      if (res === 'task' && !hasTaskCreatePermission) {
        this.popupService.openPopup(CollectionPopupComponent, 'You do not have permission to create this task type.', '', '50%');
        return;
      }
    }

    this.router.navigate(['/newtask'], {
    queryParams: { mode: res }
      });
    });
  } else {
    this.router.navigate(['/newtask']);
  }

    if (source === 'mobile') {
      this.desktopVersion();
    }
  }

  convertTime(event: MouseEvent) {
  event.stopPropagation(); // prevent mat-sort-header from triggering
  this.timezone = this.timezone === 'UTC' ? 'Local Time' : 'UTC';
  for (const result of this.taskData) {
    const convertedDates = this.convertDateAndTimes(result);
    
    result.submissionDate = convertedDates.submissionDate;
    result.startDate = convertedDates.startDate;
    result.endDate = convertedDates.endDate;

      for (const item of result.request) {
        const convertedDates = this.convertDateAndTimes(item);

        if (item.firstCapture) item.firstCaptureTime = convertedDates.firstCaptureTime;
        if (item.lastCapture) item.lastCaptureTime = convertedDates.lastCaptureTime;
      }
    }
}

  convertDateAndTimes({ createdAt, openWindow, closeWindow, firstCapture, lastCapture }: any) {
    return {
      submissionDate: this.formatDate(createdAt),
      startDate: this.formatDate(openWindow),
      endDate: this.formatDate(closeWindow),
      firstCaptureTime: this.formatDate(firstCapture),
      lastCaptureTime: this.formatDate(lastCapture)
    };
  }

  private formatDate(dateTime: string) {
    if (!dateTime) return null;

    return this.timezone === 'Local Time'
      ? this.utilsService.convertUtcToLocal(dateTime, this.currentUser)
      : dateTime;
  }

  clickTaskActions(sensor: any, task: any) {
    const dialog = this.matdialog.open(StarRatingComponent, {
      width: '45%',
      data: { task: task, type: 'tasks', sensor: sensor, currentUser: this.currentUser },
    backdropClass: 'blurred',
    disableClose: true,
  });

  dialog.afterClosed().subscribe((result) => {
    if (result != 'close') {
      this.filteredData = [];
      if (!this.selectedProjectId && !this.selectedTaskId) {
        this.getTaskList();
      }
      this.expandedElement = task.id;
    }
  });
  }
   feedsAvailabilityMap: { [sensor: string]: boolean } = {};

  checkTaskStatus(sensor: any, task: any) {
    const dialog = this.matdialog.open(ConfirmPopupComponent, {
      width: '45%',
      data: { task: task, message: 'pixxel', sensor: sensor, currentUser: this.currentUser },
      backdropClass: 'blurred',
      disableClose: true,
    });

    dialog.afterClosed().subscribe((result) => {
      if (result != 'close') {
        this.filteredData = [];
        if (!this.selectedProjectId && !this.selectedTaskId) {
          this.getTaskList();
        } else {
          this.getData(this.selectedProjectId, this.selectedTaskId);
        }
      }

        this.expandedElement = task.id;
        });
  }

  FeedsAvailabilityCheck(element: any) {
    let isOpenWater = element.openWater ? true : false;
    const indx = this.taskData.findIndex((task) => task.id === element.id);
    this.feedsAvailabilityMap = {};
    element?.request.forEach((item: any) => {
      if (this.taskData[indx]?.taskStrategy === 'Task From Collection') {
        this.feedsAvailabilityMap[item.uuid] = false;
        return;
      }
       const sensorData = {
        sensor: item.sensor,
        name: item.name,
        ...(item?.originalResolution 
          ? { resolution: item?.originalResolution ?? null }
        : { resolution: item?.resolution ?? null }),
        ...(item?.collectionMode?.[0]?.key
        ? { imaging_mode: item.collectionMode[0].key ?? null }
        : { imaging_mode: item?.collection_mode?.[0]?.key ?? null }),
        polarization: item?.sarPolarization ?? null
      };

      if (this.currentUser?.user_plan === 1) {
        this.feedsAvailabilityMap[item.uuid] = false;
      } else {
        this.apiService.getFeedsBySensorType([sensorData], isOpenWater)
          .subscribe((result: any) => {
            const hasFeeds = result?.informationServices?.length > 0 &&
              this.utilsService.hasFeatureCheck(this.currentUser?.planDetails, FEEDS) &&
              this.taskData[indx]?.taskStrategy !== 'Tip-and-Cue' &&
              this.taskData[indx]?.taskStrategy !== 'Tip-and-Cue-Outcome' &&
              !this.allocated;

            this.feedsAvailabilityMap[item.uuid] = hasFeeds;
          });
      }
    });
  }

  SelectFeeds(el: any, element: any) {
  let selectedSensors: any = [];
    selectedSensors.push({
      sensor: element.sensor,
      name: element.name,
      resolution: element?.originalResolution,
      imaging_mode: element?.collectionMode[0]?.key ?? null,
      polarization: element?.sarPolarization ?? null,
      sensorId : element?.uuid,
    });
     const sensorKey = `${el.id}_${element.uuid}`;
    const catlogRef = this.matdialog.open(
      CatalogsPopupComponent,
      {
        width: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: {taskId: el.id, sensorTypes: selectedSensors, isOpenWater: el.openWater,sensorId:element.uuid, previousSelection: this.selectedCatalogData.get(sensorKey) || [] 
          , status:element.status, feedData:element.feedData },
      }
    );
    catlogRef.afterClosed().subscribe(async (result) => {
      if (result !== 'no') {
        this.selectedCatalogData.set(sensorKey, result);
        el.mlTasks = result;
        this.allMlTasks.push(...el.mlTasks);      
      }
    });
   }
  getImageSize(status: string): number {
    const disabledStatuses = ['Unavailable', 'awaiting', 'failed', 'rejected', 'canceled'];
    return disabledStatuses.includes(status) ? 35 : 28;
  }
  


shouldShowCustomFeedDisplay(element: any): boolean {
  const hasFeedData = element?.feedData?.length > 0;
  const isUnavailable = !element?.firstCapture && element?.supportFeasibility === false && (element?.status == 'approved' || element?.status == 'ordered');
  
  if (isUnavailable) {
    return hasFeedData; // Don't check canceled status for unavailable items
  }
  
  return hasFeedData;
}

onBannerValueChange(value: boolean) {
  this.isbanneropen = value;
}

showTaskingOutcome(detail: any): boolean {
  return !!(
    detail?.outcomeCheck ||
    detail?.outcomeRejected ||
    detail?.insufficientBalance
  );
}

updateInnerNameDisplay(taskStrategy?: string) {
  if (taskStrategy === 'permission_based') {
  this.innerNameDisplay = [
    'check',
    'sensorname',
    'taskid',
    'resolution',
    'unit',
    'tasking',
    'cloudcover',
    'firstcapture',
    'lastcapture',
    'sensorcost',
    'oprtyTask',
    'feeds',
    'status',
    'action',
    'previousActor'
  ];
} else if (taskStrategy === 'Feed Based') {
    this.innerNameDisplay = [
      'check',
      'questionName',
      'questionId',
      'cost',
      'status',
    ];
  }
 else {
    this.innerNameDisplay = [
    'check',
    'sensorname',
    'taskid',
    'resolution',
    'unit',
    'tasking',
    'cloudcover',
    'firstcapture',
    'lastcapture',
    'sensorcost',
    'oprtyTask',
    'feeds',
    'status',
    'action',
  ];
}
}

}
